import { PageHeader } from "@ant-design/pro-layout";
import { useTranslation } from "@opendash/core";
import { Link, useNavigate } from "@opendash/router";
import { createComponent } from "@opendash/state";
import {} from "antd";
import React from "react";
import styled from "styled-components";
import type { AppState } from "./App.state";

const Layout = styled.div`
  background: white;
  width: 100%;
`;

const Content = styled.div`
  padding: 20px;
  width: 100%;
`;

export const KnowledgeLayout = createComponent<{
  state: AppState;
  children: React.ReactNode;
}>(function KnowledgeLayout({ state, children }) {
  const t = useTranslation();
  const navigate = useNavigate();

  let title = t("knowledge:type.language_selection");
  let subTitle = t("knowledge:title");

  const routes: { path: string; breadcrumbName: string }[] = [
    {
      path: "/knowledgebase",
      breadcrumbName: t("knowledge:title"),
    },
  ];

  if (state.language) {
    title = t("knowledge:type.category_selection");
    subTitle = state.language;

    routes.push({
      path: `/knowledgebase/${state.language}`,
      breadcrumbName: state.language,
    });
  }

  if (state.category) {
    if (state.category.parent) {
      if (state.category.parent.parent) {
        if (state.category.parent.parent.parent) {
          routes.push({
            path: `/knowledgebase/${state.language}/${state.category.parent.parent.parent.id}`,
            breadcrumbName: state.category.parent.parent.parent.label,
          });
        }

        routes.push({
          path: `/knowledgebase/${state.language}/${state.category.parent.parent.id}`,
          breadcrumbName: state.category.parent.parent.label,
        });
      }

      routes.push({
        path: `/knowledgebase/${state.language}/${state.category.parent.id}`,
        breadcrumbName: state.category.parent.label,
      });
    }

    title = state.category.label;
    subTitle = t("knowledge:title");

    routes.push({
      path: `/knowledgebase/${state.language}/${state.category.id}`,
      breadcrumbName: state.category.label,
    });
  }

  if (state.article) {
    title = state.article.label;
    subTitle = t("knowledge:title");

    routes.push({
      path: `/knowledgebase/${state.language}/${state.category.id}/article/${state.article.id}`,
      breadcrumbName: state.article.label,
    });
  }

  if (state.video) {
    title = state.video.label;
    subTitle = t("knowledge:title");

    routes.push({
      path: `/knowledgebase/${state.language}/${state.category.id}/video/${state.video.id}`,
      breadcrumbName: state.video.label,
    });
  }

  if (state.document) {
    title = state.document.label;
    subTitle = t("knowledge:title");

    routes.push({
      path: `/knowledgebase/${state.language}/${state.category.id}/document/${state.document.id}/1`,
      breadcrumbName: state.document.label,
    });
  }

  state.useForceRender();

  return (
    <Layout>
      <PageHeader
        title={title}
        subTitle={subTitle}
        breadcrumb={{
          routes,
          itemRender: (route) => (
            <Link to={route.path} children={route.breadcrumbName} />
          ),
        }}
      />
      <Content>{children}</Content>
    </Layout>
  );
});
